module.exports = __webpack_public_path__ + "img/Swaziland.82034319.svg";